export default __webpack_public_path__ + "static/media/Unova.07352936.png";